import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import CoreMap from '@bd/bdui-coremap';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { GoogleMapUrl } from '@bd/bdcore-utilities';
import AccordionToggle from '../../components/AccordionToggle';
import { colors } from '../../styles';

const styles = css`
`;

function Map({ community }) {
  return (
    <div className={styles}>
      <div className="DetailSection">
        <div className="ScrollTarget" id="map" />
        <AccordionToggle
          openOnId="map"
          button={({ contentVisible }) => (
            <div className="container DetailSection_headingWrapper">
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Map & Directions</h3>
            </div>
          )}
          noToggleDesktop
        >
          <div className="container pb-5">
            <div className="row pb-5">
              <div className="col-lg-8">
                <CoreMap
                  pin={{
                    iconUrl: '/images/icon-map-pin.svg',
                    iconSize: [32, 46],
                    iconAnchor: [16, 46],
                  }}
                  className={css`
                    position: relative;
                    padding-bottom: 56.25%;
                    width: 100%;
                    z-index: 0;

                    background-color: ${colors.neutral};
                    .leaflet-container {
                      position: absolute;
                      top: 0;
                      bottom: 0;
                      left: 0;
                      right: 0;
                    }
                  `}
                  markers={[community]}
                />
              </div>
              <div className="col-lg-4">
                <div className="mb-3 ">
                  {get(community, 'directions')}
                </div>
                <div className="text-center">
                  <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer">
                    <img src="/images/icon-map-pin.svg" alt="" /> View on Google Map
                  </a>
                </div>
              </div>
            </div>
          </div>
        </AccordionToggle>
      </div>
    </div>
  );
}

Map.propTypes = {
  community: PropTypes.object.isRequired,
};

Map.defaultProps = {
  community: undefined,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
  },
)(Map);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Map.js